<template>
  <div>
    <!--库存查询-->
    <header class="form-title">
      <Row>
        <Col span="10">
          <Form inline :label-width="80">
            <FormItem label="库存数量:" style="margin-right: 30px">
              <strong class="result">{{dataTotl.num}}</strong>
            </FormItem>
            <FormItem label="库存成本:" style="margin-right: 30px" v-if="isroule">
              <strong class="result">{{dataTotl.summoney}}</strong>
            </FormItem>
            <FormItem label="单品总数:">
              <strong class="result">{{dataTotl.warning}}</strong>
            </FormItem>
          </Form>
        </Col>
        <Col span="14">
          <Form inline>
            <FormItem style="margin-right: 1rem">
              <Input style="width: 12.5rem" v-model="code" placeholder="商品货号" />
            </FormItem>
            <FormItem style="margin-right: 1rem">
              <Input style="width: 12.5rem" v-model="condition" placeholder="商品名称" />
            </FormItem>
            <FormItem style="margin-right: 1rem">
              <Input style="width: 12.5rem" v-model="goodsMinNum" placeholder="数量>=" type="number"/>
            </FormItem>
            <FormItem style="margin-right: 1rem">
              <Input style="width: 12.5rem" v-model="goodsMaxNum" placeholder="数量<=" type="number"/>
            </FormItem>
            <FormItem style="margin-right: 1rem">
              <Input style="width: 12.5rem" v-model="supplierName" placeholder="供应商名称" />
            </FormItem>
            <FormItem style="margin-right: 1rem">
                <mt-switch v-model="inferiorFlag" style="width: 12.5rem">查残次品库存</mt-switch>
            </FormItem>
            <FormItem style="margin-right: 1rem">
                <mt-switch v-model="minusFlag" style="width: 12.5rem">单品为负数开关</mt-switch>
            </FormItem>
            
            <FormItem style="margin-right: 1rem">
              <Button type="primary" style="margin-right:1rem" @click="searchCondition">搜索</Button>
              <Button type="primary" style="" @click="qingkongs">清空</Button>
            </FormItem>
          </Form>
        </Col>
      </Row>
    </header>
    <Table stripe :columns="columns" :data="data" :loading="loadingTable" class="tableList">
      <template slot-scope="{ row, index }" slot="first">
        <Fy-Img class="img" :ImgSrc="row.goodsimg | filtImg(row.goodsimg)" :Width="50" :Height="50"></Fy-Img>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          size="small"
          @click="$router.push({path:'/waterqueryDetial',query:{id:row.id,inferior:inferiorFlag}})"
        >详情</Button>
      </template>
    </Table>
    <div class="pageTotal">
      <Page :total="page.total" show-total :page-size="page.rows" @on-change="onGongPageTotal" />
    </div>
  </div>
</template>
<script>
import FyImg from "../../components/Common/FyImg";
export default {
  components: { FyImg },
  data() {
    return {
      cid: "",
      sid: "",
      condition: "", //搜多内容
      code: "",
      goodsMinNum: "",//商品数量大于数
      goodsMaxNum: "",//商品数量大于数
      supplierid: "",//供应商ID
      minusFlag: false,//是否查询单品为负数的商品
      inferiorFlag: false,//查询残次品
      supplierName: "",//供应商名称
      typeGoodsId: "", //大分类
      typeItmeId: "", //小分类      
      columns: [
        { title: "图片", key: "goodsimg", align: "center", slot: "first" },
        { title: "商品名称", key: "name", align: "center" },
        { title: "货号", key: "goodscode", align: "center" },
        { title: "当前库存", key: "num", align: "center" },
        { title: "操作", key: "edit", align: "center", slot: "action" }
      ],
      data: [],
      dataTotl: {
        num: 0,
        summoney: 0,
        warning: 0
      },
      page: {
        total: 0,
        page: 1,
        rows: 8
      },
      loadingTable: true,
      isroule: true
    };
  },
  watch: {
    // condition: {
    //   deep: true,
    //   handler: function(newVal, oldVal) {
    //     this.selectStockList(this.page.page, this.page.rows);
    //   }
    // },
    // code: {
    //   deep: true,
    //   handler: function(newVal, oldVal) {
    //     this.selectStockList(this.page.page, this.page.rows);
    //   }
    // }
  },
  created: function() {
    //获取用户信息
    this.cid = JSON.parse(localStorage.getItem("shop")).cid;
    this.sid = JSON.parse(localStorage.getItem("shop")).id;
    this.selectStockList(this.page.page, this.page.rows);
    
    var PermisCode = JSON.parse(sessionStorage.getItem("access")).code;
    if (!PermisCode.includes("94")) {
      this.isroule = false;
    };
    // document.addEventListener('keydown', this.handleKeyDown);
    // document.addEventListener('keyup', this.handleKeyUp);
  },
  destroyed() {
//    document.removeEventListener('keydown', this.handleKeyDown);//清除绑定的时间
//    document.removeEventListener('keyup', this.handleKeyUp);//清除绑定的时间
  },
  methods: {
    // handleKeyDown(e) {
    //     var key = window.event.keyCode ? window.event.keyCode : window.event.which
    //     if( key === 67 ){
    //         this.minusFlag = true;
    //         e.preventDefault() //取消浏览器原有的当前快捷键操作
    //     }
    // },
    // handleKeyUp(e) {
    //     var key = window.event.keyCode ? window.event.keyCode : window.event.which
    //     if( key === 67 ){
    //         this.minusFlag = false;
    //         e.preventDefault()
    //     }
    // },
    searchCondition() {
      if(!this.inferiorFlag)//查询正常商品
        this.selectStockList(this.page.page, this.page.rows);
      else//查询残次品
        this.selectStockList(this.page.page, this.page.rows);
    },

    

    //获取列表
    selectStockList(page, rows) {
      let data = {
          cid: this.cid,
          sid: this.sid,
          page: page,
          rows: rows,
          goodscode: this.code,
          name: this.condition,
          typeGoodsId: this.typeGoodsId, //大分类
          typeItmeId: this.typeItmeId, //小分类 
          goodsMinNum: this.goodsMinNum,//商品数量大于数
          goodsMaxNum: this.goodsMaxNum,//商品数量大于数
          supplierid: this.supplierid,//供应商ID
          supplierName: this.supplierName,//供应商名称     
          minusFlag: this.minusFlag,//是否查询单品为负数的商品
          inferiorFlag: '0',//是否查询残次品      
        }
      if(this.inferiorFlag){
        data.inferiorFlag = '1'
      }
      this.$Api.selectStockList(data).then(res => {
          if (res.code == 200) {
            this.data = [];
            this.page.total = res.count;

            res.data.forEach((item, index) => {
              var PurchaseList = {};
              PurchaseList.id = item.id;
              PurchaseList.goodsimg = item.goodsimg;
              (PurchaseList.name = item.name),
                (PurchaseList.goodscode = item.goodscode),
                (PurchaseList.num = item.stock),
                (PurchaseList.tagCode = item.tagCode),
                this.data.push(PurchaseList);
            });
            this.loadingTable = false;
            this.selectStockNum();
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    onGongPageTotal(num) {
      this.selectStockList(num, this.page.rows);
    },
    selectStockNum() {
      let data = {
          cid: this.cid,
          sid: this.sid,
          goodscode: this.code,
          name: this.condition,
          typeGoodsId: this.typeGoodsId, //大分类
          typeItmeId: this.typeItmeId, //小分类 
          goodsMinNum: this.goodsMinNum,//商品数量大于数
          goodsMaxNum: this.goodsMaxNum,//商品数量大于数
          supplierid: this.supplierid,//供应商ID
          supplierName: this.supplierName,//供应商名称     
          minusFlag: this.minusFlag,//是否查询单品为负数的商品        
          inferiorFlag:'0',//是否为查询残次品数量          
        }
      if(this.inferiorFlag){
        data.inferiorFlag = '1'
      }
      this.$Api
        .selectStockNum(data)
        .then(res => {
          if (res.code == 200) {
            this.dataTotl.num = res.data.num;
            this.dataTotl.summoney = res.data.summoney;
            this.dataTotl.warning = res.data.count;
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    qingkongs() {
      this.code = "";
      this.condition = "";
      this.goodsMinNum = "";//商品数量大于数
      this.goodsMaxNum = "";//商品数量大于数
      this.supplierid = "";//供应商ID
      this.minusFlag = false;//是否查询单品为负数的商品
      this.supplierName = "";//供应商名称
    },    
  }
};
</script>

<style lang="scss"  scoped>
.form-title {
  line-height: 54px;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 20px;
}
.result {
  color: #ff5e5e;
}
.tableFirst {
  color: #ff5e5e;
}
.tableList .ivu-table-row td {
  padding: 10px 0;
  .img {
    display: block;
    margin: 10px auto;
  }
}
</style>